import { css, SerializedStyles } from '@emotion/react'
import styled from '@emotion/styled'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { Status, StatusState } from '../Status'

export const CatalogWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1.25rem 0;
  gap: 1.25rem;
`

export const CatalogStatus = styled(Status)<{ state: StatusState; font?: SerializedStyles }>`
  display: flex;
  flex-direction: row;
  width: fit-content;
  ${({ font }) => font || Fonts.P1};
  color: ${Colors.Ash};

  ${(props) =>
    props.state === 'active' &&
    css`
      color: ${Colors.Jet};
    `}
`
